import script from "./DropdownMenuRadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenuRadioGroup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__